import logoDark from '@/assets/images/rts-logo-dark.png'
import logoLight from '@/assets/images/rts-logo-light.png'
import { getLatestByContentType } from '@/services/contentfulClient'
import { ContentfulModel } from '@/types/contentful'
import {
  Box,
  Container,
  IconButton,
  Typography,
  useColorScheme,
} from '@mui/material'
import { format } from 'date-fns'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { MdArrowBackIos } from 'react-icons/md'
import { useNavigate } from 'react-router-dom'

export default function LegalDocument({
  type,
  popup = false,
}: {
  type: string
  popup?: boolean
}) {
  const { mode, systemMode } = useColorScheme()
  const resolvedMode = (systemMode || mode) as 'light' | 'dark'
  const [contentModel, setContentModel] = useState<ContentfulModel | null>(null)
  const { t } = useTranslation()
  const navigate = useNavigate()

  useEffect(() => {
    getLatestByContentType(type).then(setContentModel)
  }, [])

  return (
    <Container
      maxWidth="lg"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        mt: popup ? 2 : 4,
        p: popup ? '4px!important' : 4,
      }}
    >
      {!popup && (
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <IconButton
            onClick={() => navigate('/')}
            disableRipple
            color="primary"
            aria-label={t('back')}
            size="small"
          >
            <MdArrowBackIos size="1em" />
            {t('back')}
          </IconButton>
        </Box>
      )}
      <Typography>
        {resolvedMode === 'dark' ? (
          <img src={logoLight} width={70} alt="" aria-hidden="true" />
        ) : (
          <img src={logoDark} width={70} alt="" aria-hidden="true" />
        )}
      </Typography>
      {contentModel ? (
        <Box className="contentContainer" sx={{ mt: 3 }}>
          <Typography
            variant="h4"
            component="h3"
            dangerouslySetInnerHTML={{ __html: contentModel.title ?? '' }}
          />

          {contentModel.updatedDate ? (
            <Typography variant="subtitle2" sx={{ mt: 1 }}>
              {t('last-modified', {
                date: format(
                  new Date(contentModel.updatedDate),
                  'MMMM d, yyyy'
                ),
              })}
            </Typography>
          ) : null}
          <Box
            component="article"
            sx={{ textAlign: 'justify' }}
            dangerouslySetInnerHTML={{ __html: contentModel.content ?? '' }}
          />
        </Box>
      ) : null}
    </Container>
  )
}
